// extracted by mini-css-extract-plugin
export default {"answersContainer":"AnswerOptions_answersContainer__Hz7-4","optionText":"AnswerOptions_optionText__7tLLv","activeAnswer":"AnswerOptions_activeAnswer__TMoOM"};